import * as types from './mutation-types'

export const fetchSettlements = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/settlements`, { params }).then((response) => {
            commit(types.SET_SETTLEMENTS, response.data.settlements.data)
            commit(types.SET_TOTAL_SETTLEMENTS, response.data.settlements.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchSettlement = ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/settlements/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchEditSettlementData = ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/settlements/${id}/edit`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchCreateSettlement = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/settlements/create`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addSettlement = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/settlements', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateSettlement = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/settlements/${data.id}`, data.editData).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectSettlement = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_SETTLEMENTS, data)
    if (state.selectedSettlements.length === state.settlements.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}

export const selectAllSettlements = ({ commit, dispatch, state }) => {
    if (state.selectedSettlements.length === state.settlements.length) {
        commit(types.SET_SELECTED_SETTLEMENTS, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allPaymentIds = state.selectedSettlements.map(pay => pay.id)
        commit(types.SET_SELECTED_SETTLEMENTS, allPaymentIds)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}

export const searchSettlement = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/settlements?${data}`).then((response) => {
            // commit(types.UPDATE_INVOICE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
